import React, { useState } from "react";

import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { sortBy } from "lodash";

export function contextOptionFormatter(contextKey) {
  return function formatValue(params) {
    const options = params.context[contextKey] || [];
    return (
      options.find(option => {
        return option.value === params.value;
      })?.label || ""
    );
  };
}

export function listValueFormatter(valueFormatter) {
  return function formatListValue(params) {
    return Array.isArray(params.value)
      ? params.value.map(value => valueFormatter({ ...params, value }))
      : valueFormatter(params);
  };
}

export function listCellEditorParamsGetter(cellEditorParamsGetter) {
  return function getCellEditorParams(params) {
    return { ...cellEditorParamsGetter(params), multiple: true };
  };
}

export function contextOptionCellEditorParamsGetter(
  contextKey,
  prefilter = null,
  sortIteratee = "label",
) {
  return function getCellEditorParams(params) {
    const options = params.context[contextKey] || [];
    return {
      values: sortBy(
        options.filter(
          prefilter
            ? (val, index, arr) => prefilter(val, index, arr, params)
            : Boolean,
        ),
        sortIteratee,
      ).map(option => option.value),
      isClearable: true,
    };
  };
}

export const AutoCompleteV2 = props => {
  const {
    filterOptions,
    multiple,
    options: providedOptions,
    renderOption,
    value,
    values,
  } = props;

  const [pendingValue, setPendingValue] = useState(value);

  const options = values || providedOptions;

  function onChangeHandler(e, newValue) {
    const parsed = props.parseValue ? props.parseValue(newValue) : newValue;
    setPendingValue(parsed);
    props.onValueChange?.(parsed);
    if (!multiple) {
      props.stopEditing?.();
    }
  }

  return (
    <MuiAutocomplete
      style={{ width: 300 }}
      filterOptions={filterOptions}
      value={pendingValue}
      options={options}
      openOnFocus
      multiple={multiple}
      onChange={onChangeHandler}
      getOptionLabel={props.formatValue}
      disableClearable={!props.isClearable}
      renderInput={params => {
        return (
          <div ref={params.InputProps.ref}>
            {params.InputProps.startAdornment
              ?.map(selectedOption => selectedOption.props.label)
              .join(", ")}
            <input
              type="text"
              tabIndex={-1}
              {...params.inputProps}
              className="ag-input-field-input ag-text-field-input"
            />
          </div>
        );
      }}
      renderOption={renderOption}
    />
  );
};
